import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { server_API } from "../config";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';
import { selectCid } from '../features/companyid';
import { TailSpin } from "react-loader-spinner";
import Select from 'react-select'
import { IoMdArrowBack } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import Copyright from "../components/Copyright";
import axiosInstance from "../axiosInstance";

const itemsPerPage = 10;
const NewUser = () => {
  const navigate = useNavigate()
  const [admin, setAdmin] = useState(false);
  const [recruiter, setRecruiter] = useState(false);
  const [hiringManager, setHiringManager] = useState(false);
  const [email, setEmail] = useState("");
  const [ws, setWs] = useState("");
  const [user, setUser] = useState([])
  const [name, setName] = useState("");
  const [companyUsers, setCompanyUsers] = useState([])
  const [popupVisible, setPopupVisible] = useState(false);
  const [activeUuid, setactiveUuid] = useState("")
  const [recallLoader, setrecallLoader] = useState(false)
  const [reminderLoader, setreminderLoader] = useState(false)
  const [userLoader, setUserLoader] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [paginatedUsers, setPaginatedUsers] = useState([])
  const [selectallLoader, setSelectallLoader] = useState(false)
  const [action, setAction] = useState("")
  const [selectallaction, setSelectallAction] = useState("")
  const [acceptedPopup, setAcceptedPopup] = useState(false)
  const [info, setInfo] = useState(false)
  const [sentPopup, setSentPopup] = useState(false)
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isApprover, setIsApprover] = useState(false);
  const [salaryApprover, setSalaryApprover] = useState(false);
  const [jobApprover, setJobApprover] = useState(false);
  const [offerLetterApprover, setOfferLetterApprover] = useState(false);
  const [signature, setSignature] = useState(null);
  const [hasApproverFlow, setHasApproverFlow] = useState(false);

  const cid = useSelector(selectCid)

  const [selectedUuids, setSelectedUuids] = useState([]);

  // Check if all users on the current page are selected
  const isPageFullySelected = paginatedUsers.every((user) => selectedUuids.includes(user.uuid));

  const handleSelectAll = () => {
    if (isPageFullySelected) {
      // Deselect all users on the current page
      setSelectedUuids((prev) =>
        prev.filter((uuid) => !paginatedUsers.some((user) => user.uuid === uuid))
      );
    } else {
      // Select all users on the current page
      setSelectedUuids((prev) => [
        ...prev,
        ...paginatedUsers
          .filter((user) => !prev.includes(user.uuid))
          .map((user) => user.uuid),
      ]);
    }
  };

  const handleSelect = (uuid) => {
    setSelectedUuids((prev) =>
      prev.includes(uuid) ? prev.filter((id) => id !== uuid) : [...prev, uuid]
    );
  };
  const viewOptions = [
    { value: 'recall', label: 'Recall' },
    { value: 'reminder', label: 'Remind' },
  ]

  useEffect(() => {
    if (admin) {
      setWs("Admin");
    } else if (recruiter) {
      setWs("Recruiter");
    } else if (hiringManager) {
      setWs("Hiring Manager");
    }
  }, [admin, recruiter, hiringManager]);

  const sendInvite = () => {
    setUserLoader(true)
    const formData = new FormData();
    formData.append("companyid", cid);
    formData.append("privilege", ws);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("status", "sent");
    formData.append("password", "password");
    formData.append("is_approver", isApprover);
    formData.append("salary_approver", salaryApprover);
    formData.append("job_approver", jobApprover);
    formData.append("offer_letter_approver", offerLetterApprover);
    if (signature) {
      formData.append("signature", signature);
    }

    axios.post(`${server_API}/v2/user/create`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setUserLoader(false)
        toast("Email sent to user!", {
          position: "top-right",
          className: "bg-green-500 text-white"
        });

        window.location.reload()
        // navigate('/user')
      })
      .catch((err) => {
        //   if (err.status == 409){
        //     setSentPopup(true)
        //   } else{
        //   alert("Invitation mail can't be sent Please try again.");
        // }

        console.log({ err });

        toast(err?.response?.data?.message || "Invitation mail can't be sent Please try again.", {
          position: "top-right",
          type: "error"
        });
        setUserLoader(false)
        console.log(err)
      })

  }

  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex for email validation
    if (!email) {
      setError("Email is required");
    } else if (!emailRegex.test(email)) {
      setError("Invalid email format");
    } else {
      setError(""); // No error if valid
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0)
    axiosInstance.get(`/v2/user/company/${cid}`)
      .then((response) => {
        console.log(response)
        setUser(response.data.message.Users)
      })
      .catch((err) => { console.log(err) })

    axios
      .get(`${server_API}/v2/company/get/${cid}`)
      .then((response) => {
        setHasApproverFlow(response.data.hasApproverFlow || response.data.offerApproval);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [])

  useEffect(() => {
    if (user.length > 0 && cid.length > 0) {
      const new_users = user.filter((m) => {
        if ((cid === m.companyid) && (m.status === "sent")) {
          return m
        }
      })
      setCompanyUsers(new_users)
    }

  }, [user, cid, email])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const trimmedEmail = email.trim();

      if (trimmedEmail.length === 0) {
        setactiveUuid("");
        setPopupVisible(false);
        setAcceptedPopup(false);
        setFilteredUsers([])
        return;
      }

      const new_users = companyUsers.filter((m) => m.email.trim() === trimmedEmail);
      const accepted_users = user.filter((m) => m.email.trim() === trimmedEmail && m.status === "accepted");

      if (new_users.length > 0) {
        setactiveUuid(new_users[0].uuid);
        setPopupVisible(true);
      } else {
        setactiveUuid("");
        setPopupVisible(false);
      }

      setAcceptedPopup(accepted_users.length > 0);
      setFilteredUsers(new_users);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [email, companyUsers, user]);





  const handleRecallOrReminder = (type, uuid) => {
    axios.post(`${server_API}/v2/user/trigger/${type}`, {
      "userid": [uuid]
    })
      .then((response) => {
        console.log(response)
        if (type == "recall") {
          setrecallLoader(false)
        }
        if (type == "reminder") {
          setreminderLoader(false)
        }
        setSelectallLoader(false)

        toast("Email sent to user!", {
          position: "top-right",
          className: "bg-green-500 text-white"
        });
        setPopupVisible(false)
        setEmail("")
        setName("")
        setAdmin(false);
        setRecruiter(false);
        setHiringManager(false);
        window.location.reload()
      })
      .catch((err) => {
        alert("Reminder or recall mail can't be sent Please try again.");
        setrecallLoader(false)
        setreminderLoader(false)
        setSelectallLoader(false)
        console.log(err)
      })
  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
  };

  const indexOfLastJob = currentPage * itemsPerPage;
  const indexOfFirstJob = indexOfLastJob - itemsPerPage;
  useEffect(() => {
    const displayedUsers = filteredUsers.length > 0 ? filteredUsers : companyUsers;
    setPaginatedUsers(
      displayedUsers.slice(indexOfFirstJob, indexOfLastJob)
    )
  }, [currentPage, companyUsers, email, filteredUsers])

  // const currentJobs = sortedJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalPages = Math.ceil(companyUsers.length / itemsPerPage);


  const getPageRange = () => {
    const maxVisiblePages = 3;
    const middlePage = currentPage;
    let startPage = middlePage - Math.floor(maxVisiblePages / 2);
    startPage = Math.max(startPage, 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };


  const handleApiCall = async (type) => {
    setSelectallLoader(true)
    if (selectedUuids.length === 0) {
      alert("Please select at least one user.");
      return;
    }

    try {
      axios.post(`${server_API}/v2/user/trigger/${type}`, {
        "userid": selectedUuids
      }).then((response) => {
        console.log(response)
        toast("Email sent to Selected user!", {
          position: "top-right",
          className: "bg-green-500 text-white"
        });
        setSelectallLoader(false)
        setSelectedUuids([])
        window.location.reload()
      })

    } catch (error) {
      console.error("Error in API calls:", error);
      alert("Some API calls failed. Please try again.");
      setSelectallLoader(false)
    }
  };

  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setInfo(false);
      }
    }

    if (info) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [info]);


  return (
    <div className="bg-[#f0f4fc] min-h-screen pb-8">
      {
        popupVisible &&
        <div className="">
          <div className="fixed bg-white border shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
              <div className="flex  items-center justify-between">
                <p className="text-xl ">Warning</p>
                <button onClick={() => {
                  setPopupVisible(false)
                  setEmail("")
                  setName("")
                  setAcceptedPopup(false)
                  setAdmin(false);
                  setRecruiter(false);
                  setHiringManager(false);
                  setFilteredUsers([])
                }} className="text-right">X</button>
              </div>
              <div className="h-[0.08rem] w-full  bg-gray-300"></div>
              <div>
                <p className="my-6 font-semibold">New User invitation has been sent to {email}, Remind or Recall now</p>

              </div>
              <div className="flex gap-5 items-center justify-center">
                <button onClick={() => {
                  handleRecallOrReminder("recall", activeUuid)
                  setrecallLoader(true)
                }} className=" text-blue-500 border border-blue-500  outline-none px-10 py-2 rounded-lg" disabled={recallLoader}>
                  {recallLoader ? (
                    <TailSpin color="black" height="30" width="30"></TailSpin>
                  ) : (
                    "Recall"
                  )}
                </button>
                <button onClick={() => {
                  handleRecallOrReminder("reminder", activeUuid)
                  setreminderLoader(true)
                }} className=" text-white bg-blue-500 outline-none px-10 py-2 rounded-lg" disabled={reminderLoader}>
                  {reminderLoader ? (
                    <TailSpin color="white" height="30" width="30"></TailSpin>
                  ) : (
                    "Remind"
                  )}
                </button>

              </div>

            </div>
          </div>
        </div>
      }

      {
        sentPopup &&
        <div className="">
          <div className="fixed bg-white border shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
              <div className="flex  items-center justify-between">
                <p className="text-xl ">Warning</p>
                <button onClick={() => {
                  setSentPopup(false)
                  setEmail("")
                  setName("")

                  setAdmin(false);
                  setRecruiter(false);
                  setHiringManager(false);
                }} className="text-right">X</button>
              </div>
              <div className="h-[0.08rem] w-full  bg-gray-300"></div>
              <div className="flex flex-col gap-1">
                <p className="mt-6 font-semibold">New User invitation has been sent to {email}.</p>
                <span> Write to <a href="mailto:support@northstarz.ai" className="text-blue-400">support@northstarz.ai</a> for assistance.</span>

              </div>


            </div>
          </div>
        </div>
      }
      {
        selectallLoader &&
        <div className="">
          <div className="fixed bg-white border shadow-xl md:w-[20%]  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
              <div className="flex flex-col items-center  justify-center">
                <TailSpin color="black" height="50" width="50"></TailSpin>
              </div>




            </div>
          </div>
        </div>
      }
      <ToastContainer></ToastContainer>
      <div className={popupVisible || selectallLoader || sentPopup ? " blur px-10 pt-5 flex flex-col gap-4" : "px-10 pt-5 flex flex-col gap-4"}>
        <p className="text-2xl font-semibold"><span><IoMdArrowBack className="text-2xl my-3  tooltip" onClick={() => { navigate(-1) }}>back</IoMdArrowBack></span> Add New User</p>
        <div className="bg-white rounded-xl shadow-xl">
          <div className="flex w-full items-end justify-start py-6">
            <div className="px-4 font-bold border-l-4 border-l-blue-600">
              Send Invitation
            </div>
          </div>
          <div className="border-[0.5px] border-gray-200"></div>
          <div className="p-6 bg-white rounded-xl ">
            <div className="flex w-full mb-2 items-start justify-start space-x-5">
              <div className="w-1/3">
                <p className="font-semibold text-[#263871]">
                  Email <span className="text-red-400">*</span>
                </p>
                <input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    validateEmail(e.target.value);
                  }}
                  className={`w-full px-1 py-1 rounded-lg mt-1 border ${error || acceptedPopup ? "border-red-500" : "border-gray-300"
                    }`}
                  placeholder="xyz@gmail.com"
                />
                {error && !acceptedPopup && <p className="font-normal text-red-500">{error}</p>}
                {acceptedPopup && (<>
                  <p className="font-normal text-red-500">Email is already registered</p>
                </>)}
              </div>
              <div className="w-1/4">
                <p className="font-semibold text-[#263871]">Name <span className="text-red-400">*</span></p>
                <input
                  className="border w-full px-1 py-1 rounded-lg mt-1"
                  type="text"
                  value={name}
                  onChange={(e) => { setName(e.target.value) }}
                  placeholder="User Name"
                ></input>
              </div>
              <div className="">
                <div className="flex items-center gap-2">
                  <p className="font-semibold">Access for <span className="text-red-400">*</span></p>
                  <div className="tooltip relative" ref={tooltipRef}>
                    <button
                      onClick={() => {
                        setInfo(!info);
                      }}
                    >
                      <FaInfoCircle className="text-lg mt-[0.5rem]"></FaInfoCircle>
                    </button>
                    {info && (
                      <div className="fixed rounded-xl  z-50 p-3 mr-3  bg-[#1d2a3c]">

                        <div className="text-white">
                          <strong>Admin:</strong> Full administrative control over
                          the ATS, including user management, system
                          configurations, and access to all data and features.{" "}
                          <br />
                          <br />
                          <strong>Recruiter:</strong> Manage job postings, review
                          submitted candidates, schedule interviews, and add
                          candidate ratings and notes. No administrative access.
                          <br />
                          <br />
                          <strong>Hiring Manager:</strong> Review submitted
                          candidates, schedule interviews, and add candidate
                          ratings and notes. No administrative or job creation
                          access.
                        </div>

                      </div>
                    )}
                  </div>
                </div>

                <div className="flex my-2 items-center w-full space-x-3">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked == true) {
                          setAdmin(true);
                          setRecruiter(false);
                          setHiringManager(false);
                        }
                      }}
                      checked={admin}
                      className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                    ></input>
                    <p>Admin</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      onChange={(e) => {
                        if (e.target.checked == true) {
                          setAdmin(false);
                          setRecruiter(true);
                          setHiringManager(false);
                        }
                      }}
                      checked={recruiter}
                      type="checkbox"
                      className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                    ></input>
                    <p>Recruiter</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      onChange={(e) => {
                        if (e.target.checked == true) {
                          setAdmin(false);
                          setRecruiter(false);
                          setHiringManager(true);
                        }
                      }}
                      checked={hiringManager}
                      type="checkbox"
                      className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                    ></input>
                    <p>Hiring Manager</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Approver Selection */}
          {hasApproverFlow && (
            <div>
              <div className="mt-4 mx-4 px-3">
                <div className="flex gap-3 items-center mb-2">
                  <p className="font-semibold">Is Approver?</p>
                  <div className="flex space-x-4">
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="approverYes"
                        name="isApprover"
                        value="yes"
                        checked={isApprover === true}
                        onChange={() => setIsApprover(true)}
                        className="cursor-pointer"
                      />
                      <label htmlFor="approverYes" className="cursor-pointer">Yes</label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="approverNo"
                        name="isApprover"
                        value="no"
                        checked={isApprover === false}
                        onChange={() => {
                          setIsApprover(false);
                          setSalaryApprover(false);
                          setJobApprover(false);
                          setOfferLetterApprover(false);
                        }}
                        className="cursor-pointer"
                      />
                      <label htmlFor="approverNo" className="cursor-pointer">No</label>
                    </div>
                  </div>

                  {/* Sub-Roles Checkboxes (Visible only if Is Approver is Yes) */}
                  {isApprover && (
                    <div className="ml-10 flex space-x-6">
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={salaryApprover}
                          onChange={(e) => setSalaryApprover(e.target.checked)}
                          className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                        />
                        <p>Salary Approver</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={jobApprover}
                          onChange={(e) => setJobApprover(e.target.checked)}
                          className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                        />
                        <p>Job Approver</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={offerLetterApprover}
                          onChange={(e) => setOfferLetterApprover(e.target.checked)}
                          className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                        />
                        <p>Offer Letter Approver</p>
                      </div>
                    </div>
                  )}

                </div>

                {/* Signature Upload */}
                {offerLetterApprover && (
                  <div className="my-4 flex gap-8 items-center">
                    <p className="font-semibold">Signature</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setSignature(e.target.files[0])}
                      className="mt-2 w-full text-sm text-gray-500
                          file:mr-4 file:py-2 file:px-4
                          file:rounded-full file:border-0
                          file:text-sm file:font-semibold
                          file:bg-blue-50 file:text-blue-700
                          hover:file:bg-blue-100"
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="w-full py-[0.02rem]  bg-gray-200"></div>
          <div className="text-right space-x-4 flex justify-between p-4">
            <button className="border-blue-400 border text-blue-400 outline-none px-5 py-2 rounded-lg" onClick={() => {
              setEmail("")
              setName("")
              setAdmin(false);
              setRecruiter(false);
              setHiringManager(false);
            }}>
              Reset
            </button>
            <button onClick={() => {
              sendInvite()
            }} className={`text-white px-5 py-2 rounded-lg ${(offerLetterApprover && !signature) ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500"}`} disabled={!(name.length > 0 &&
              email.length > 0 && ws.length > 0) || userLoader || acceptedPopup || popupVisible || error || (offerLetterApprover && !signature)}>
              {userLoader ? (
                <TailSpin color="white" height="30" width="30"></TailSpin>
              ) : (
                "Send Invite"
              )}
            </button>
          </div>
        </div>

        <div className="bg-white rounded-xl ">
          <div className="flex w-full items-end justify-start py-6">
            <div className="px-4 font-bold border-l-4 border-l-blue-600">
              Pending User Activation
            </div>
          </div>
          <div className="border-[0.5px] border-gray-200"></div>

          <div className="pt-6 px-4 flex  justify-between">
            <div>
            </div><Select value={selectallaction}
              placeholder=" Select Action"
              isDisabled={selectedUuids.length == 0}
              onChange={(option) => {
                handleApiCall(option.value)

              }}
              options={viewOptions}></Select></div>
          <div className="px-4 ">


            {
              paginatedUsers.length > 0 ?
                <div className="pt-6">
                  <Table className="border-y">
                    <Thead className="text-center top-0 z-30 bg-white">
                      <Tr>
                        <Th className="border-y p-4">
                          <input
                            type="checkbox"
                            checked={isPageFullySelected}
                            onChange={handleSelectAll}
                          />
                        </Th>
                        <Th className="border-y p-4">S. No.</Th>
                        <Th className="border-y p-4 ">Name</Th>
                        <Th className="border-y p-4">Email</Th>
                        <Th className="border-y p-4">Sent Date</Th>
                        <Th className="border-y p-4">Access</Th>

                        <Th className="border-y p-4">Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody className="text-center">
                      {
                        paginatedUsers.map((e, i) => {
                          return (
                            <Tr>
                              <Td className="border-y p-4">
                                <input
                                  type="checkbox"
                                  checked={selectedUuids.includes(e.uuid)}
                                  onChange={() => handleSelect(e.uuid)}
                                />
                              </Td>
                              <Td className="border-y p-4">{indexOfFirstJob + i + 1}</Td>
                              <Td className="border-y p-4 ">{e.name}</Td>
                              <Td className="border-y p-4">{e.email}</Td>
                              <Td className="border-y p-4">{`${(e.createdat.split('T')[0]).split('-')[2]}-${(e.createdat.split('T')[0]).split('-')[1]}-${(e.createdat.split('T')[0]).split('-')[0]}`}</Td>
                              <Td className="border-y p-4">{e.privilege}</Td>

                              <Td className="border-y text-left p-4"><Select value={action}
                                placeholder=" Select Action"
                                onChange={(option) => {

                                  handleRecallOrReminder(option.value, e.uuid)
                                  setSelectallLoader(true)

                                }}
                                options={viewOptions}></Select></Td>
                            </Tr>
                          )
                        })
                      }
                    </Tbody>
                  </Table>
                </div>
                :
                <div>
                  No data to be displayed
                </div>
            }
          </div>
          <nav className="bg-white px-4 py-6 flex items-center justify-between  sm:px-6 ">
            <div className="hidden sm:block">
              {companyUsers.length !== 0 ? (
                <p className="text-sm text-gray-700">
                  {indexOfFirstJob + 1} to {companyUsers.length < indexOfLastJob ? companyUsers.length : currentPage !== totalPages ? indexOfLastJob : companyUsers.length} of {companyUsers.length} User
                </p>
              ) : (
                <p className="text-sm text-gray-700">
                  {0} to {0} of {companyUsers.length} users
                </p>
              )}
            </div>
            <div className="flex justify-between sm:justify-end gap-1">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === 1 ? "opacity-50" : "hover:bg-gray-50"
                  }`}
              >
                Previous
              </button>
              <div className="flex space-x-2">
                {currentPage > 4 && (
                  <>
                    <button
                      onClick={() => handlePageChange(1)}
                      className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 1 ? "bg-light-blue text-white" : ""
                        }`}
                    >
                      1
                    </button>
                    <button
                      onClick={() => handlePageChange(2)}
                      className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 2 ? "bg-light-blue text-white" : ""
                        }`}
                    >
                      2
                    </button>
                    <span className="px-2 text-gray-500 text-4xl flex ">...</span>
                  </>
                )}
                {getPageRange().map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === page ? "bg-light-blue text-white" : ""
                      }`}
                  >
                    {page}
                  </button>
                ))}
              </div>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === totalPages ? "opacity-50" : "hover:bg-gray-50"
                  }`}
              >
                Next
              </button>
            </div>
          </nav>
        </div>

      </div>
      <Copyright></Copyright>
    </div >
  );
};

export default NewUser;
